import client from "./sharedoClient";
import { direction } from "@/util/sort";

const defaultGetOptions = {
    filter: "",
    includeTemplateAuthorContentBlocks: true,
    includeDocumentAuthorContentBlocks: true,
    sort: {
        by: "title",
        direction: direction.ASCENDING
    },
    paging: {
        page: 1,
        pageSize: 10
    }
};

const get = options => {
    const opts = Object.assign({}, defaultGetOptions, options);

    const payload = {
        sortColumn: opts.sort.by,
        sortDirection: opts.sort.direction,
        page: opts.paging.page,
        pageSize: opts.paging.pageSize,
        tags: opts.tags,
        includeOpenXmlTemplates: opts.includeOpenXmlTemplates,
        systemNames: opts.systemNames,
        includeTemplateAuthorContentBlocks: opts.includeTemplateAuthorContentBlocks,
        includeDocumentAuthorContentBlocks: opts.includeDocumentAuthorContentBlocks
    };

    if (opts.filter) {
        payload.queryText = opts.filter;
    }

    return client.post("api/wordaddin/contentBlocks/_list", payload);
}

const getOne = systemName => client.get(`api/wordaddin/contentBlocks/${systemName}`);

const loadOne = (systemName, sharedoId) => {
    const url = "api/wordaddin/contentBlocks/_load";
    const payload = {
        blockSystemName: systemName
    };

    if (sharedoId) {
        payload.sharedoId = sharedoId
    }

    return client.post(url, payload);
}

const getTags = (query, includeOpenXmlTemplates = false) => {
    const payload = {
        includeOpenXmlTemplates,
        queryText: query
    };

    return client.post("api/wordaddin/contentBlocks/tagCounts", payload);
}

const add = contentBlock => client.post("api/wordaddin/contentBlocks/_create", contentBlock);

const markAsUsed = (contentBlock, sharedoActivityId, templateSystemName) => {
    const payload = {
        contentSystemName: contentBlock.systemName,
        sharedoActivityId,
        templateSystemName
    };

    return client.post("api/wordaddin/contentBlocks/_use", payload);
}

const markAsUnused = (contentBlock, sharedoActivityId, templateSystemName) => {
    const payload = {
        contentSystemName: contentBlock.systemName,
        sharedoActivityId,
        templateSystemName
    };

    return client.post("api/wordaddin/contentBlocks/_disuse", payload);
}

export default {
    get,
    getOne,
    loadOne,
    getTags,
    add,
    markAsUsed,
    markAsUnused
}